import * as Yup from 'yup';

export const ServerMediaSchema = Yup.object({
    path: Yup.string()
        .trim()
        .max(200, 'must be less than equal to 200 characters long')
        .required('The path field is required.'),
    file_name: Yup.string()
        .trim()
        .max(200, 'must be less than equal to 200 characters long')
        .required('The file name field is required.'),
    orig_name: Yup.string()
        .trim()
        .max(200, 'must be less than equal to 200 characters long')
        .required('The original name field is required.'),
    attach_id: Yup.number()
        .nullable(),
    attachment_for: Yup.string()
        .nullable(),
    reference_id: Yup.string()
        .nullable(),
    is_image: Yup.boolean()
        .nullable(),
    user_id: Yup.number()
        .required('The user id field is required.')
})

export default ServerMediaSchema;
